import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var loginRoute = [{
  path: "login",
  name: "accountLogin",
  component: function component() {
    return import("./login.vue");
  }
}];